import { createWebHistory as createHistory, createRouter } from "vue-router";
import setupMetaTags from "../routing/metaTags";
import setupRedirects from "../routing/redirects";
import routes from "../routing/routez.js";
export * from "../routing/routes";

const router = createRouter({
  history: createHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // If user used browser back/forward, restore saved scroll position
    if (savedPosition) {
      return savedPosition;
    } else {
      // Always scroll to top
      return { left: 0, top: 0 };
    }
  },
});

setupMetaTags(router);
setupRedirects(router);

export default router;
